import { css } from 'styled-components';
import { colors } from '../../style-utilities/variables';
export default css`
  padding: 10px 40px 6px;
  &:hover {
    background: ${colors.primaryHover};
  }
`;
